var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-3 pl-1" },
      [
        _c(
          "b-form-group",
          { staticClass: "mb-3" },
          [
            _c("b-form-input", {
              attrs: {
                id: "search",
                placeholder: "Busqueda",
                name: "search",
                size: "sm"
              },
              on: { input: _vm.onTheFlyChange },
              model: {
                value: _vm.onTheFlyConfig.name,
                callback: function($$v) {
                  _vm.$set(_vm.onTheFlyConfig, "name", $$v)
                },
                expression: "onTheFlyConfig.name"
              }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }